module.exports={close:"Закрыть",error:"Ошибка",info:"Информация",success:"Успешно",warning:"Предупреждение"};